import { Show, createMemo } from 'solid-js';
import { setFitTarget, clearSlot } from '../state/actions';
import { checkDpi } from '../core/dpi';
import type { Slot } from '../types';

export function SlotRowExpanded(props: { slot: Slot }) {
  const dpi = createMemo(() =>
    props.slot.image ? checkDpi(props.slot.image, props.slot.fitTarget) : null,
  );

  return (
    <div class="slot-row-expanded" onClick={(e) => e.stopPropagation()}>
      <Show
        when={props.slot.image}
        fallback={
          <div class="slot-row-expanded__hint">Tap circle to add photo</div>
        }
      >
        <div class="slot-row-expanded__row">
          <div class="slot-row-expanded__fit">
            <button
              type="button"
              class="slot-row-expanded__fit-btn"
              data-fit="centre"
              aria-pressed={props.slot.fitTarget === 'centre'}
              onClick={() => setFitTarget(props.slot.id, 'centre')}
            >
              Centre
            </button>
            <button
              type="button"
              class="slot-row-expanded__fit-btn"
              data-fit="bleed"
              aria-pressed={props.slot.fitTarget === 'bleed'}
              onClick={() => setFitTarget(props.slot.id, 'bleed')}
            >
              Bleed
            </button>
          </div>
          <button
            type="button"
            class="slot-row-expanded__remove"
            data-action="remove"
            onClick={() => clearSlot(props.slot.id)}
          >
            Remove
          </button>
        </div>
        <Show when={dpi() && !dpi()!.ok}>
          <div class="slot-row-expanded__dpi">
            ⚠ Recommended ≥ {dpi()!.required}×{dpi()!.required} for 300 DPI
          </div>
        </Show>
      </Show>
    </div>
  );
}
